import Component from '../core/Component'

export const STATES = {
    ACTIVE: 'is-active',
    MOBILE: 'is-mobile-active'
}

export default class StoreDropdownToggle extends Component {

    constructor(element) {
        super(element)

        this.eventHandlers = {
            open:  ::this.handleOpen,
            close: ::this.handleClose
        }
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    destroy() {
        const categories = Component.getFromElement(this.element.getAttribute('href').replace('#', ''))

        if (categories) {
            categories.off(this.eventHandlers)
        }
    }

    handleClick(event) {
        const categories = Component.getFromElement(this.element.getAttribute('href').replace('#', ''))

        if (categories) {
            event.preventDefault()
            event.stopPropagation()
            categories.on(this.eventHandlers)
            categories.toggle()
        }
    }

    handleOpen() {
        this.element.classList.add(STATES.ACTIVE)
        this.element.classList.add(STATES.MOBILE)
    }

    handleClose() {
        this.element.classList.remove(STATES.ACTIVE)
        this.element.classList.remove(STATES.MOBILE)
    }
}
